import { sword_slash_2h } from "../../../abilities/sword/sword-actions-2h";
const CLAYMORE = {
  slug: "claymore",
  name: "Claymore",
  description: "Scottish fury",
  rarity: "rare",
  slot: "weapon",
  shopCategory: "2h-melee",
  statChanges: [
    {
      stat: "attackDamage",
      value: 25
    },
    {
      stat: "attackspeed",
      value: 3
    }
  ],
  grantedActions: { sword_slash_2h },
  sprite: {
    sheet: "weapons/melee_weapons/sword_big",
    frameIndex: 1
  },
  tags: ["daily-rotation", "two-handed", "2h-melee"]
};
export {
  CLAYMORE
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL3dlYXBvbnMvdHdvLWhhbmRlZC1zd29yZHMvY2xheW1vcmUudHMiXSwKICAic291cmNlc0NvbnRlbnQiOiBbIi8qKlxuICogQ2xheW1vcmUgLSBSYXJlIHR3by1oYW5kZWQgd2VhcG9uXG4gKi9cblxuaW1wb3J0IHsgc3dvcmRfc2xhc2hfMmggfSBmcm9tICcuLi8uLi8uLi9hYmlsaXRpZXMvc3dvcmQvc3dvcmQtYWN0aW9ucy0yaCc7XG5pbXBvcnQgeyBJdGVtRGVmaW5pdGlvbiB9IGZyb20gJy4uLy4uL3R5cGVzJztcblxuZXhwb3J0IGNvbnN0IENMQVlNT1JFOiBJdGVtRGVmaW5pdGlvbiA9IHtcbiAgc2x1ZzogJ2NsYXltb3JlJyxcbiAgbmFtZTogJ0NsYXltb3JlJyxcbiAgZGVzY3JpcHRpb246ICdTY290dGlzaCBmdXJ5JyxcbiAgcmFyaXR5OiAncmFyZScsXG4gIHNsb3Q6ICd3ZWFwb24nLFxuXG4gIHNob3BDYXRlZ29yeTogJzJoLW1lbGVlJyxcbiAgc3RhdENoYW5nZXM6IFtcbiAgICB7XG4gICAgICBzdGF0OiAnYXR0YWNrRGFtYWdlJyxcbiAgICAgIHZhbHVlOiAyNSxcbiAgICB9LFxuICAgIHtcbiAgICAgIHN0YXQ6ICdhdHRhY2tzcGVlZCcsXG4gICAgICB2YWx1ZTogMyxcbiAgICB9LFxuICBdLFxuICBncmFudGVkQWN0aW9uczogeyBzd29yZF9zbGFzaF8yaCB9LFxuICBzcHJpdGU6IHtcbiAgICBzaGVldDogJ3dlYXBvbnMvbWVsZWVfd2VhcG9ucy9zd29yZF9iaWcnLFxuICAgIGZyYW1lSW5kZXg6IDEsXG4gIH0sXG4gIHRhZ3M6IFsnZGFpbHktcm90YXRpb24nLCAndHdvLWhhbmRlZCcsICcyaC1tZWxlZSddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUlBLFNBQVMsc0JBQXNCO0FBR3hCLE1BQU0sV0FBMkI7QUFBQSxFQUN0QyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFFTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWDtBQUFBLE1BQ0UsTUFBTTtBQUFBLE1BQ04sT0FBTztBQUFBLElBQ1Q7QUFBQSxJQUNBO0FBQUEsTUFDRSxNQUFNO0FBQUEsTUFDTixPQUFPO0FBQUEsSUFDVDtBQUFBLEVBQ0Y7QUFBQSxFQUNBLGdCQUFnQixFQUFFLGVBQWU7QUFBQSxFQUNqQyxRQUFRO0FBQUEsSUFDTixPQUFPO0FBQUEsSUFDUCxZQUFZO0FBQUEsRUFDZDtBQUFBLEVBQ0EsTUFBTSxDQUFDLGtCQUFrQixjQUFjLFVBQVU7QUFDbkQ7IiwKICAibmFtZXMiOiBbXQp9Cg==
